/* Kameristas 48HFP: scoped tabs and one cart request per action. */
(function () {
  'use strict';
  function init() {
    var root = document.getElementById('k48-page');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var tabs = Array.from(root.querySelectorAll('[data-k48-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-k48-panel]'));
    var tablist = root.querySelector('[data-k48-tabs]');
    function selectTab(name, focus) {
      tabs.forEach(function (tab) {
        var selected = tab.dataset.k48Tab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
      panels.forEach(function (panel) { panel.hidden = panel.dataset.k48Panel !== name; });
    }
    if (tablist && tabs.length && tabs.length === panels.length) {
      root.classList.add('k48-enhanced');
      tablist.hidden = false;
      tablist.setAttribute('role', 'tablist');
      tabs.forEach(function (tab, index) {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', 'k48-panel-' + tab.dataset.k48Tab);
        tab.addEventListener('click', function () { selectTab(tab.dataset.k48Tab, false); });
        tab.addEventListener('keydown', function (event) {
          var target = index;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = tabs.length - 1;
          else return;
          event.preventDefault(); selectTab(tabs[target].dataset.k48Tab, true);
        });
      });
      panels.forEach(function (panel) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', 'k48-tab-' + panel.dataset.k48Panel);
        panel.tabIndex = 0;
      });
      selectTab('kameros', false);
    }
    root.querySelectorAll('a.k48-details-link').forEach(function (link) {
      link.target = '_blank'; link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', link.textContent.trim() + ' (naujame skirtuke)');
    });
    var handlers = new Map();
    root.querySelectorAll('[data-k48-form]').forEach(function (form) {
      var control = form.querySelector('[data-k48-variant]');
      var button = form.querySelector('[data-k48-add]');
      var price = form.querySelector('[data-k48-price]');
      var status = form.querySelector('[data-k48-status]');
      if (!control || !button || !price || !status) return;
      button.type = 'button';
      var busy = false;
      function variant() {
        var option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        if (!option || !control.value) return null;
        return { id: Number(control.value), available: option.dataset.available === 'true', price: Number(option.dataset.price), formatted: option.dataset.formattedPrice || '' };
      }
      function update(clear) {
        var v = variant();
        if (clear) { status.textContent = ''; status.removeAttribute('data-error'); }
        price.classList.toggle('k48-price-pending', !v || !(v.price > 0));
        price.textContent = !v ? 'Pasirink komplektaciją' : v.price > 0 ? v.formatted : 'Kaina ruošiama';
        button.disabled = busy || !v || !v.available || !(v.price > 0);
        button.textContent = busy ? 'Pridedama…' : !v ? 'Pasirink komplektaciją' : !(v.price > 0) ? 'Pasiūlymas ruošiamas' : !v.available ? 'Šiuo metu neprieinama' : 'Pridėti į krepšelį';
      }
      function cartLink(url) {
        var link = document.createElement('a');
        link.href = url.href; link.textContent = 'Peržiūrėti krepšelį ↗';
        link.style.textDecoration = 'underline';
        status.appendChild(document.createTextNode(' ')); status.appendChild(link);
      }
      control.addEventListener('change', function () { update(true); });
      update(true);
      handlers.set(form, async function () {
        if (busy) return;
        var v = variant();
        if (!v || !Number.isSafeInteger(v.id) || v.id <= 0 || !v.available || !(v.price > 0)) { update(true); return; }
        if (root.dataset.preview === 'true') { status.textContent = 'Tai dizaino peržiūra. Produktas nepridėtas.'; return; }
        busy = true; update(true); form.setAttribute('aria-busy', 'true');
        var abort = new AbortController();
        var timeout = setTimeout(function () { abort.abort(); }, 15000);
        var cart;
        try {
          var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          var endpoint = new URL(root.dataset.addUrl || base + 'cart/add.js', location.origin);
          cart = new URL(root.dataset.cartUrl || base + 'cart', location.origin);
          if (endpoint.origin !== location.origin || cart.origin !== location.origin) throw new Error('Invalid route');
          var response = await fetch(endpoint.href, {
            method: 'POST', credentials: 'same-origin', signal: abort.signal,
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: { 'Pasiūlymas': '48HFP Vilnius' } }] })
          });
          var result = await response.json();
          if (!response.ok) {
            var failure = new Error('Rejected');
            failure.rejected = response.status >= 400 && response.status < 500;
            throw failure;
          }
          if (!result.items || !result.items.some(function (item) { return Number(item.variant_id || item.id) === v.id; })) throw new Error('Missing confirmation');
          status.textContent = 'Pridėta į krepšelį.';
          cartLink(cart);
          // The current theme refreshes its cart counter with a read-only request.
          try { if (window.theme && typeof window.theme.afterCartLoad === 'function') window.theme.afterCartLoad(); } catch (ignore) {}
        } catch (error) {
          status.dataset.error = 'true';
          status.textContent = error.rejected ? 'Šio komplekto pridėti nepavyko. Patikrink jo prieinamumą produkto puslapyje.' : 'Nepavyko patvirtinti pridėjimo. Prieš bandydamas dar kartą patikrink krepšelį.';
          if (cart && cart.origin === location.origin) cartLink(cart);
        } finally {
          clearTimeout(timeout); busy = false; form.removeAttribute('aria-busy'); update(false);
        }
      });
    });
    // Intercept only this landing page's cart controls before theme/app handlers.
    window.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-k48-add]');
      if (!button || !root.contains(button)) return;
      var form = button.closest('[data-k48-form]');
      if (!handlers.has(form)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (!button.disabled) handlers.get(form)();
    }, true);
    window.addEventListener('submit', function (event) {
      if (!handlers.has(event.target)) return;
      event.preventDefault(); event.stopImmediatePropagation(); handlers.get(event.target)();
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
